import { render, staticRenderFns } from "./OpenBillingSettings.vue?vue&type=template&id=53fb763d&"
import script from "./OpenBillingSettings.vue?vue&type=script&lang=js&"
export * from "./OpenBillingSettings.vue?vue&type=script&lang=js&"
import style0 from "./OpenBillingSettings.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports